export * from "./arcRotateCameraVRDeviceOrientationInput.types";
/**
 * Re-exports pure implementation and applies runtime side effects.
 * Import arcRotateCameraVRDeviceOrientationInput.pure for tree-shakeable, side-effect-free usage.
 */
export * from "./arcRotateCameraVRDeviceOrientationInput.pure";

import { RegisterArcRotateCameraVRDeviceOrientationInput } from "./arcRotateCameraVRDeviceOrientationInput.pure";
RegisterArcRotateCameraVRDeviceOrientationInput();
